import { Component, Input } from '@angular/core';
import { IPeriodsESDPResults } from '@interfaces/IPeriodResults';

@Component({
  selector: 'app-table-student-esdp-result',
  templateUrl: './table-student-esdp-result.component.html',
  styleUrls: ['./table-student-esdp-result.component.sass'],
})
export class TableStudentEsdpResultComponent {
  @Input() results: IPeriodsESDPResults[] | [] = [];
}
